'use strict';
import { observable, action } from 'mobx';
import { fetch } from '@/lib/fetchAPI';
import appFileStore from '../AppFile/AppFile';
import globalStore from '../Global';

class AppFirmwareStore {
  @observable firmwareListArr = [];

  @action
  loadFirmwareList() {
    fetch(`/api/ota/file/all`, { method: 'GET' }, json => {
      this.firmwareListArr = [...json] || [];
    });
  }
  @action
  addFirmware(data) {
    globalStore.loadingStatus = true;
    globalStore.loadingTip = '正在上传中...';
    fetch(
      `/api/ota/file`,
      {
        method: 'POST',
        body: data
      },
      json => {
        this.loadFirmwareList();
        appFileStore.appModal = false;
        globalStore.loadingStatus = false;
        globalStore.loadingTip = '';
      }
    );
  }
  @action.bound
  deleteFirmware(name) {
    fetch(`/api/ota/file?file_name=${name}`, { method: 'DELETE' }, data => {
      this.loadFirmwareList();
    });
  }
}
export default new AppFirmwareStore();



// WEBPACK FOOTER //
// ./src/store/AppFirmware/AppFirmware.js